export default __webpack_public_path__ + "static/media/group-7360.dfb4136b.svg";